import { Decimal } from 'decimal.js';

// Set the default rounding mode to half-away-from-zero instead of rounding towards-positive-infinity like Math.round()
// This fixes binary/float rounding issues where things like -1.5 rounds to -1 instead of -2
Decimal.set({ 
  rounding: Decimal.ROUND_HALF_UP 
});

export { Decimal };